<template>
  <div>
    <b-modal
      id="isShowthankspop"
      class="cust-app-modal popupwidth modal-cont"
      hide-header
      ok-only
      @ok="() => this.$bvModal.hide('isShowapp')"
    >
      <!-- hide-footer -->
      <!-- @show="timer" -->
      <BetaAccesspopup />
    </b-modal>
    <div class="lg:pl-10 md:pl-10 pl-5 lg:pr-0 md:pr-0 pr-5 custoverflow">
      <div class="absolute top-5 mob-hidden">
        <h2 class="text-101828 font-semibold fsize24 sm-fsize20">
          Get Early Beta Access to Our App!
        </h2>
      </div>
      <h2 class="text-101828 pt-5 font-semibold fsize35 sm-fsize20 web-hidden">
        Get Early Beta Access to Our App!
      </h2>
      <div class="flex justify-between lg:gap-2 md:gap-2">
        <div class="lg:pt-20 md:pt-10 pt-5">
          <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
              <div class="w-full">
                <p class="text-344054 fsize15 font-semibold">
                  Name <span class="clr-red">*</span>
                </p>
                <base-input
                  v-model="fullName"
                  placeholder="Enter Name"
                  name="First Name"
                  class="cust-form-border"
                  :rules="{ required: true, regex: '^[a-zA-Z0-9 ]+$' }"
                ></base-input>
                <!-- <span v-if="nameErr" class="small text-danger">{{
              errMsg.name
            }}</span> -->
              </div>
              <div class="w-full pt-4">
                <p class="text-344054 fsize15 font-semibold">
                  Email <span class="clr-red">*</span>
                </p>
                <base-input
                  :rules="{ required: true, email: true }"
                  name="Email"
                  v-model="email"
                  placeholder="Enter address"
                  class="cust-form-border"
                ></base-input>
                <!-- <span v-if="emailErr" class="small text-danger">{{
              errMsg.email
            }}</span> -->
              </div>
              <div class="w-full pt-4">
                <p class="text-344054 fsize15 font-semibold">
                  Phone Number <span class="clr-red">*</span>
                </p>
                <base-input
                  :rules="{ required: true, regex: '^[0-9]+$' }"
                  v-model="mobile"
                  name="Phone Number"
                  placeholder="Phone number"
                  class="cust-form-border"
                ></base-input>
                <!-- <span v-if="mobileErr" class="small text-danger">{{
              errMsg.mobile
            }}</span> -->
              </div>
              <div class="pt-4">
                <p class="text-344054 font-semibold">
                  Select all the role(s) apply to you
                  <!-- <span class="clr-red">*</span> -->
                </p>
                <div
                  class="grid lg:grid-cols-3 md:grid-cols-3 grid-cols-2 gap-2 pt-2"
                >
                  <div>
                    <b-form-checkbox
                      class="custcheck"
                      name="role"
                      value="Active Caregiver"
                      v-model="role"
                      ><p class="fsize14 text-black">
                        Active Caregiver
                      </p></b-form-checkbox
                    >
                  </div>
                  <div>
                    <b-form-checkbox
                      class="custcheck"
                      name="role"
                      value="Potential Caregiver"
                      v-model="role"
                      ><p class="fsize14 text-black">
                        Potential Caregiver
                      </p></b-form-checkbox
                    >
                  </div>
                  <div class="lg:ml-5">
                    <b-form-checkbox
                      class="custcheck"
                      name="role"
                      value="Volunteer"
                      v-model="role"
                      ><p class="fsize14 text-black">
                        Volunteer
                      </p></b-form-checkbox
                    >
                  </div>
                  <div class="lg:pt-2">
                    <b-form-checkbox
                      class="custcheck"
                      name="role"
                      value="HR Professional"
                      v-model="role"
                      ><p class="fsize14 text-black">
                        HR Professional
                      </p></b-form-checkbox
                    >
                  </div>
                  <div class="lg:pt-2 w-108per">
                    <b-form-checkbox
                      class="custcheck"
                      name="role"
                      value="Corporate Professional"
                      v-model="role"
                      ><p class="fsize14 text-black">
                        Corporate Professional
                      </p></b-form-checkbox
                    >
                  </div>
                  <div class="lg:ml-5 lg:pt-2">
                    <b-form-checkbox
                      class="custcheck"
                      name="role"
                      value="Other"
                      v-model="role"
                      ><p class="fsize14 text-black mt-1">
                        Other
                      </p></b-form-checkbox
                    >
                  </div>
                  <span v-if="roleErr" class="small text-danger">{{
                    errMsg.role
                  }}</span>
                </div>
              </div>
              <div class="pt-3">
                <p class="pb-2 text-344054 font-semibold">
                  What features would you like to see in the app?
                </p>

                <b-form-textarea
                  placeholder="Tell us a little about what features you'd like..."
                  v-model="description"
                  :name="'description'"
                  class="cust-form-border"
                ></b-form-textarea>
                <!-- <span v-if="descErr" class="small text-danger">{{
                  errMsg.desc
                }}</span> -->
              </div>
              <div class="py-4">
                <b-form-checkbox
                  id="checkbox-2"
                  v-model="isSubscribed"
                  class="cust1"
                >
                  <p>
                    <strong>
                      <p class="col-blk">
                        Subscribe to our newsletter and get regular updates
                      </p></strong
                    >
                  </p></b-form-checkbox
                >
              </div>

              <div class="flex items-center justify-center mb-6">
                <!-- v-b-modal.isShowthankspop -->
                <base-button
                  :disabled="
                    fullName.trim() == '' ||
                    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ||
                    !/^[6-9]\d{9}$/.test(mobile) ||
                    !role.length
                  "
                  native-type="submit"
                  type="primary"
                  class="w-full rounded-full font-semibold bdr-8"
                  >Request Early Access</base-button
                >
                <!-- @click="onSubmit" -->
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div class="relative">
          <div class="mob-hidden">
            <!-- src="https://nexuscluster.blob.core.windows.net/server01/caregiversaathi/image/Phone%20Image.png" -->
            <img
              src="@/assets/images/get app.png"
              alt="img"
              class="w-325px custimgradius img-h object-cover"
            />
          </div>
          <div
            class="absolute top-3 right-3 bg-primary rounded-full p-1 text-white mob-hidden cursor-pointer"
          >
            <feather-icon icon="XIcon" @click="handleClose" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BetaAccesspopup from "./BetaAccesspopup.vue";
import { mapState } from "vuex";
export default {
  components: {
    BetaAccesspopup,
  },
  data() {
    return {
      fullName: "",
      mobile: "",
      email: "",
      role: [],
      isSubscribed: false,
      description: "",
      emailErr: false,
      nameErr: false,
      mobileErr: false,
      roleErr: false,
      // descErr: false,
      errMsg: {},
    };
  },
  methods: {
    handleClose() {
      this.$bvModal.hide("isShowapp");
    },
    async onSubmit() {
      this.roleErr = false;
      if (!this.role.length) {
        this.roleErr = true;
        this.errMsg.role = "You must choose a role";
        return;
      } else {
        this.roleErr = false;
      }

      let payload = {
        fullName: this.fullName.trim(),
        mobile: this.mobile.trim(),
        email: this.email.trim(),
        description: this.description.trim(),
        role: this.role,
        isSubscribed: this.isSubscribed,
      };
      try {
        let data = await this.$store.dispatch(
          "services/createAppForm",
          payload
        );
        this.$bvModal.show("isShowthankspop");

        // this.$bvModal.hide("isShowthankspop");
        // if (data.code == 200) {
        //   this.$swal.fire({
        //     // text: "Announcement Edit Successfully",
        //     icon: "success",
        //     confirmButtonText: "Okay",
        //     confirmButtonColor: "#830c81",
        //     showCancelButton: false,
        //   });
        // }
      } catch (error) {
        console.log(error);
      }
    },
    resetForm() {
      this.fullName = "";
      this.email = "";
      this.mobile = "";
      this.description = "";
      this.role = [];
      this.isSubscribed = false;
    },
  },
  timer() {
    setTimeout(() => {
      this.$bvModal.hide("isShowthankspop");
    }, 1500);
  },
  mounted() {
    if (!!Object.keys(this.user).length) {
      this.email = this.user.email;
      this.fullName = `${this.user.firstname} ${this.user.lastname}`;
      this.mobile = this.user.mobile;
      this.designation = this.user["designtion"] ? this.user["designtion"] : "";
      this.company = this.user["companyName"] ? this.user["companyName"] : "";
    }
  },
  computed: {
    ...mapState("auth", { user: "user" }),
  },
};
</script>

<style>
.w-325px {
  width: 364px;
}
.cust-form-border .form-group {
  margin-bottom: 0 !important;
}
@media (max-width: 640px) {
  .custoverflow {
    overflow-x: auto;
    height: 625px;
  }
}
.custcheck.modal-content {
  border-radius: 2rem !important;
}
.custimgradius {
  border-radius: 2rem !important;
}
.custcheck.custom-checkbox .custom-control-label::before {
  border-radius: 1rem;
}
.text-101828 {
  color: #101828 !important;
}
.text-344054 {
  color: #344054 !important;
}
.custcheck.custom-control {
  padding-left: 2rem !important;
}
.custcheck .custom-control-label::before {
  left: -2rem !important;
}
.custcheck .custom-control-label::after {
  left: -2rem !important;
}
.img-h {
  height: 705px !important;
}
.cust1 .custom-control-label::before {
  left: -2rem !important;
}
.cust1 .custom-control-label::after {
  left: -2rem !important;
}
.cust1.custom-control {
  padding-left: 2rem !important;
}

.clr-red {
  color: red;
}
@media (min-width: 641px) {
  .w-108per {
    width: 108%;
  }
}
</style>
